
















































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { SurchargeStore } from "@/mixins/store";

/** FUMBSD-761: rate and date come from the API (GET /prices/surcharge) */
@Component
export default class PriceSurchargeModal extends mixins(SurchargeStore) {
  protected get surchargeValue(): string {
    return this.surcharge.label;
  }

  protected get surchargeDate(): string | null {
    return this.surcharge.effective_date;
  }
}
